import {
  getRoutePresentation,
  type AppChromeMode,
  type AppDockMode,
  type RoutePresentation,
} from '@/app/lib/routePresentation';

export type { AppChromeMode, AppDockMode, RoutePresentation as PagePresentation };

/**
 * Compatibility entry point for shared chrome consumers. Route ownership now
 * lives in routePresentation.ts so chrome, backgrounds, and the reference
 * catalog cannot silently describe different route families.
 */
export function getPagePresentation(pathname: string): RoutePresentation {
  return getRoutePresentation(pathname);
}

export function getAppChromeMode(pathname: string): AppChromeMode {
  return getRoutePresentation(pathname).chromeMode;
}

/** The semester selector is deliberately limited to routes that consume it. */
export function shouldShowGlobalSemesterSelector(pathname: string): boolean {
  return pathname === '/' || [
    '/explore',
    '/classes-on-map',
    '/classes-by-time',
    '/course-sniper',
    '/course-list',
  ].some((route) => pathname === route || pathname.startsWith(`${route}/`));
}
